import axios from 'axios';

import { closeAblyClient } from './ably';
import { JsonResponse } from 'core/models/response';
import { LoginResponse, RegistrationStep } from 'modules/main/auth/login/models/login';

export type AuthenticationAction =
	| 'companyOverview'
	| 'companyDocumentView'
	| 'companyUserManagement'
	| 'registryTransactionAction'
	| 'heirloomTransactionAction'
	| 'shareHolderInformationAction'
	| 'noticeAction'
	| 'suspendAction'
	| 'chargePoints'
	| 'announcementAction'
	| 'CustomerService'
	| 'updateDocumentAction'
	| 'financialStatementAction'
	| 'assemblyAction'
	| 'updateBrandIdentity'
	| 'BoardMeeting'
	| 'Board'
	| 'updateAuthorizedCapital'
	| 'raiseCapital'
	| 'dividends'
	| 'Committee'
	| 'CommitteeMeeting'
	| 'LoyaltyProgram';

export const getUserFromToken = async () => {
	try {
		const response = await axios.get<JsonResponse<LoginResponse>>('me');
		return response.data.data;
	} catch (error) {
		throw error;
	}
};

class AuthService {
	private _permissions: string[] = [];
	private _isMainAdmin: boolean = false;
	private _registrationStep: RegistrationStep | null = null;

	setToken(token: string, save: boolean) {
		sessionStorage.setItem('token', token);
		if (save) localStorage.setItem('token', token);
	}

	setData(isMainAdmin: boolean, permissions: string[], registrationStep: RegistrationStep | null) {
		this._isMainAdmin = isMainAdmin;
		this._registrationStep = registrationStep;
		this._permissions = permissions;
	}

	get token(): string | null {
		return sessionStorage.getItem('token') || localStorage.getItem('token');
	}

	get isMainAdmin(): boolean {
		return this._isMainAdmin;
	}

	get registrationStep(): RegistrationStep | null {
		return this._registrationStep;
	}

	get permissions() {
		return this._permissions;
	}

	clearAuthData(): void {
		localStorage.removeItem('token');
		sessionStorage.removeItem('token');

		// the realtime connection must not outlive the session
		closeAblyClient();
	}

	isPermittedToAction(action: AuthenticationAction) {
		return this.isMainAdmin || this.permissions.includes(action);
	}

	isPermittedToActionModule() {
		return (
			this.isMainAdmin ||
			this.permissions.includes('shareHolderInformationAction') ||
			this.permissions.includes('registryTransactionAction') ||
			this.permissions.includes('heirloomTransactionAction') ||
			this.permissions.includes('suspendAction') ||
			this.permissions.includes('noticeAction') ||
			this.permissions.includes('announcementAction') ||
			this.permissions.includes('updateDocumentAction') ||
			this.permissions.includes('financialStatementAction') ||
			this.permissions.includes('assemblyAction')
		);
	}
}

// Export a singleton instance of AuthService
const authService = new AuthService();
export default authService;
